import { GifteeProperties } from 'shared/build/types';
import { Gender } from 'shared/build/enums';

export class Giftee implements GifteeProperties {
  article: string;
  gender: Gender | undefined;
  name: string;
  nickname: string;

  constructor() {
    this.article = '';
    this.gender = undefined;
    this.name = '';
    this.nickname = '';
  }

  static forge(basicGiftee: GifteeProperties): Giftee {
    const giftee = new Giftee();
    Object.assign(giftee, basicGiftee);

    return giftee;
  }

  gifteeName(): string {
    return this.name;
  }

  nameToShow(): string {
    return `${this.article} ${this.gifteeName()}`;
  }

  static joinGiftees(giftees: Giftee[], andConjunction: string): string {
    if (giftees.length === 0) return '';

    if (giftees.length === 1) return giftees[0].gifteeName();

    const copyOfGiftees = [...giftees];
    const lastGiftee = copyOfGiftees.pop();

    let gifteesNames: string = copyOfGiftees
      .map((giftee) => giftee.gifteeName())
      .join(', ');
    gifteesNames += ` e ${lastGiftee?.gifteeName()}`;

    return gifteesNames;
  }
}
